import PropTypes from "prop-types";
import SoftButton from "components/SoftButton";

function DeleteTableButton({ onClick }) {
  return (
    <SoftButton
      sx={{
        cursor: "pointer",
        userSelect: "none",
        ml: 2,
        px: 2,
        py: 0,
        fontSize: "0.65rem",
        fontWeight: "bold",
        minWidth: "unset",
        height: "16px",
        lineHeight: 1,
        textTransform: "none",
      }}
      variant="contained"
      size="small"
      color="error"
      onClick={onClick}
    >
      Delete
    </SoftButton>
  );
}

DeleteTableButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default DeleteTableButton;
